import { call, put, select, takeLatest } from 'redux-saga/effects';
import api from '@control-front-end/common/sagas/api';
import AppUtils from '@control-front-end/utils/utils';
import { Utils } from 'mw-style-react';
import {
  ACCOUNTS,
  GET_USERS,
  SET_ACTIVE_ACC,
  SET_NEW_ACC,
  ACCOUNT_CREATE,
  ACCOUNT_UPDATE,
  ACCOUNT_DELETE,
  DEL_MODAL,
  RequestStatus,
} from '../constants';
import { GET_SYSTEM_FORMS } from '../constants/forms';

function getAccountFromPath(pathname) {
  const pathParts = pathname.split('/');
  return pathParts[2];
}

function* setAccountsList(list, newAccId) {
  yield put({ type: ACCOUNTS.SUCCESS, payload: list });
  const accId =
    newAccId ||
    getAccountFromPath(document.location.pathname) ||
    Utils.fromStorage('workspaceId');
  let matchedAccount = list.find((acc) => acc.id.startsWith(accId));
  if (!matchedAccount) matchedAccount = list[0];
  const { id: active } = matchedAccount;
  yield put({ type: SET_ACTIVE_ACC, payload: active });
  if (newAccId) yield put({ type: SET_NEW_ACC, payload: newAccId });
  yield put({ type: GET_USERS.REQUEST, payload: active });
  yield put({
    type: GET_SYSTEM_FORMS.REQUEST,
    payload: { accId: active, formTypes: 'system' },
  });
}

/**
 * Получить список аккаунтов
 * @returns {IterableIterator<*>}
 */
function* getAccounts() {
  const { result, data } = yield call(api, {
    method: 'get',
    url: '/workspaces',
  });
  if (result !== RequestStatus.SUCCESS) return;
  if (data.data.length) {
    yield call(setAccountsList, data.data);
  } else {
    const auth = yield select((state) => state.auth);
    yield put({ type: ACCOUNTS.SUCCESS, payload: [] });
    yield put({ type: ACCOUNT_CREATE.REQUEST, payload: { name: auth.login } });
  }
}

/**
 * Создать аккаунт
 * @returns {IterableIterator<*>}
 */
function* createAccount({ payload, formActions }) {
  const { result, data } = yield call(api, {
    method: 'post',
    url: '/workspaces',
    body: payload,
  });
  if (formActions) formActions.setSubmitting(false);
  if (result !== RequestStatus.SUCCESS) return;
  yield call(setAccountsList, data.list, data.newAccId);
  yield put({ type: DEL_MODAL });
  document.location.href = `/events/${AppUtils.makeShortAccountId(
    data.newAccId
  )}/list`;
}

/**
 * Обновить аккаунт
 * @returns {IterableIterator<*>}
 */
function* updateAccount({ payload, formActions }) {
  const { list, active: accId } = yield select((state) => state.accounts);
  const { name } = payload;
  const { result } = yield call(api, {
    method: 'put',
    url: `/workspaces/${accId}`,
    body: payload,
  });
  if (formActions) formActions.setSubmitting(false);
  if (result !== RequestStatus.SUCCESS) return;
  const index = list.findIndex((i) => i.id === accId);
  list[index].name = name;
  yield put({ type: ACCOUNTS.SUCCESS, payload: list });
  yield put({ type: SET_ACTIVE_ACC, payload: accId });
}

/**
 * Удалить аккаунт
 * @returns {IterableIterator<*>}
 */
function* deleteAccount({ formActions }) {
  const { list, active: accId } = yield select((state) => state.accounts);
  const { result } = yield call(api, {
    method: 'delete',
    url: `/workspaces/${accId}`,
  });
  if (formActions) formActions.setSubmitting(false);
  if (result !== RequestStatus.SUCCESS) return;
  const index = list.findIndex((i) => i.id === accId);
  list.splice(index, 1);
  yield call(setAccountsList, list);
  document.location.href = '/';
}

function* accounts() {
  yield takeLatest(ACCOUNTS.REQUEST, getAccounts);
  yield takeLatest(ACCOUNT_CREATE.REQUEST, createAccount);
  yield takeLatest(ACCOUNT_UPDATE.REQUEST, updateAccount);
  yield takeLatest(ACCOUNT_DELETE.REQUEST, deleteAccount);
}

export default accounts;
